module.exports = __webpack_public_path__ + "static/media/Timer_AERO.019bc380.svg";